import { useState, type FormEvent } from "react";

interface CreateSessionFormProps {
    onCreated: () => void;
    onCreate: (name: string) => Promise<void>;
}

export function CreateSessionForm({ onCreated, onCreate }: CreateSessionFormProps) {
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    async function handleSubmit(e: FormEvent) {
        e.preventDefault();
        if (!name.trim()) return;

        setLoading(true);
        setError(null);

        try {
            await onCreate(name.trim());
            setName("");
            onCreated();
        } catch (err) {
            setError(err instanceof Error ? err.message : "Failed to create session");
        } finally {
            setLoading(false);
        }
    }

    return (
        <form onSubmit={handleSubmit} className="flex gap-3 mb-8 flex-wrap">
            <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Session name (e.g., Leg Day)"
                className="flex-1 min-w-50 px-4 py-3 bg-bg border-2 border-primary rounded-lg text-primary text-base outline-none focus:border-primary-hover placeholder:text-primary/40"
                disabled={loading}
            />
            <button
                type="submit"
                disabled={loading || !name.trim()}
                className="px-5 py-2.5 rounded-lg font-semibold text-sm bg-primary text-bg hover:bg-primary-hover transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
                {loading ? "Creating..." : "Create Session"}
            </button>
            {error && <p className="w-full text-stop mt-2 text-sm">{error}</p>}
        </form>
    );
}
